import './Beatmap.css';
import notLoaded from '../../images/notLoaded.jpg';
import BeatmapOverlay from './BeatmapOverlay';
import { useState, useEffect } from 'react';

function Beatmap(props) {
  const [cleared, setCleared] = useState('');

  useEffect(() => {
    if (window.localStorage.getItem(props.diffID)) {
      setCleared('complete');
    }
  }, []);

  function removeClear() {
    window.localStorage.removeItem(props.diffID);
    setCleared('');
  }
  return (
    <div className="beatmap">
      <BeatmapOverlay
        beatmap={props.download}
        diffID={props.diffID}
        cleared={cleared}
        removeClear={removeClear}
      />
      <img
        className="main-photo"
        src={props.image}
        alt={props.name.split(`[${[props.beatmap]}].osu`)[0]}
        onError={({ currentTarget }) => {
          currentTarget.onerror = null;
          currentTarget.src = notLoaded;
        }}
      />
      <div className="details-container">
        <span
          className="diff-color"
          style={{
            position: 'absolute',
            right: '5%',
            top: '5%',
            backgroundPositionX: `${props.diff * 10}%`,
          }}
        >
          ★ {props.diff.toFixed(2)}
        </span>
        <img
          className="bg-photo"
          src={props.image}
          alt={props.name}
          onError={({ currentTarget }) => {
            currentTarget.onerror = null;
            currentTarget.src = notLoaded;
          }}
        />
        <div className="title-name">
          <h4 className="title-text">{props.name}</h4>
          <h6>{props.artist}</h6>
          <p className="mapper-section">
            Mapped by: <span className="mapper-name">{props.mapper}</span>
          </p>
        </div>
        <p className="diff-name">
          <span className="shadow">Difficulty: </span>
          <span
            className="diff-color"
            style={{ backgroundPositionX: `${props.diff * 10}%` }}
          >
            {props.beatmap}
          </span>
        </p>
      </div>
    </div>
  );
}

export default Beatmap;
